import styled, { css, keyframes } from "styled-components";
import { style } from "../style";

type SammyProps = {
  sammy: true;
};

type SpinnerProps = {
  sammy?: false;
  small?: boolean;
};

type Props = SammyProps | SpinnerProps;

const sizeView = 100;
const waveLength = 30;
const waveHeight = 10;

const swimAnimation = keyframes`
  0% {
    transform: translateZ(0) scale(1.4);
  }

  20% {
    transform: translate3d(0, -8px, 0) rotate(-13deg) scale(1.4);
  }

  30% {
    transform: translate3d(0, -12px, 0) rotate(-13deg) scale(1.4);
  }

  50% {
    transform: translate3d(0, -20px, 0) rotate(2.5deg) scale(1.4);
  }

  70% {
    transform: translate3d(0, -10px, 0) rotate(18deg) scale(1.4);
  }

  80% {
    transform: translate3d(0, -5px, 0) rotate(18deg) scale(1.4);
  }

  90% {
    transform: translateZ(0) rotate(9deg) scale(1.4);
  }

  100% {
    transform: translateZ(0) scale(1.4);
  }
`;

const waveAnimation = keyframes`
  0% {
    transform: translateZ(0) scale(0.3);
  }

  100% {
    transform: translate3d(-${waveLength}px, 0, 0) scale(0.3);
  }
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const sammyCss = css`
  width: ${sizeView}px;
  height: ${sizeView}px;
  filter: brightness(3.45);
  overflow: hidden;
  margin: 0 auto;

  &::after {
    content: url("data:image/svg+xml;base64,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");
    transform-origin: 50%;
    width: 0;
    height: 0;
    margin: ${waveLength}px;
    animation: ${swimAnimation} 1.2s infinite linear;
    will-change: transform;
  }

  &::before {
    content: url("data:image/svg+xml;base64,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");
    will-change: transform;
    animation: ${waveAnimation} 0.95s infinite linear;
    width: ${sizeView + waveLength}px;
    height: ${waveHeight}px;
    margin-left: ${-1 * (waveLength * 2)}px;
  }
`;

const spinnerCss = (small: boolean = false) => {
  let units: string;

  if (small) {
    units = "1rem";
  } else {
    units = "1.375rem";
  }

  return css`
    border: ${style.vars.borderWidth.base} solid currentColor;
    border-radius: 50%;
    border-bottom-color: transparent;
    height: ${units};
    width: ${units};
    display: inline-block;
    animation: ${rotateAnimation} 0.75s 0s linear infinite normal both;
  `;
};

export const LoadingState = styled.div.attrs({
  role: "status",
  "aria-busy": true,
})<Props>`
  color: ${style.colors.blue.dark};
  position: relative;

  &::after,
  &::before {
    content: "";
    display: block;
  }

  ${(props) => (props.sammy ? sammyCss : spinnerCss(props.small))}
`;
